import * as types from '../action-types';

export default function setEditBasketValidationMessage(message) {
  return {type: types.SET_EDIT_BASKET_VALIDATION_MESSAGE, message};
}
